import { Button } from '@/fsd/shared/ui';
import DoneIcon from '@/fsd/shared/ui/icons/done';
import LabelBgIcon from '@/fsd/shared/ui/icons/label-bg';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { postPayment } from '../../api/postPayment/postPayment';
import { ITariffFeature } from '../../model/types/ITariffFeature';
import { ITariffOption } from '../../model/types/ITariffOption';
import { ITariffType } from '../../model/types/ITariffType';
import styles from './TariffCard.module.scss';

interface IProps {
  pricingId?: number;
  title: string;
  desc: string;
  numberOfLegalEntities: string;
  revenue: string;
  features: ITariffOption[];
  daysLeft?: string;
  initialPrice?: string;
  discountPrice: string;
  type?: ITariffType;
  showPayButton?: boolean;
}

const TariffCard = observer(
  ({
    pricingId,
    title,
    desc,
    numberOfLegalEntities,
    revenue,
    features,
    daysLeft,
    initialPrice,
    discountPrice,
    type = 'default',
    showPayButton = true,
  }: IProps) => {
    const labelText = useMemo(() => {
      if (type === 'your-tariff') return 'Ваш тариф';
      if (type === 'popular') return 'Популярный';
    }, [type]);

    const onClick = async () => {
      if (pricingId) {
        const data = await postPayment({ tariff_price_id: pricingId });
        window.location.href = data.confirmation_url;
      }
    };

    return (
      <div className={styles.wrapper}>
        <div className={cx(styles.label, styles[`type__${type}`])}>
          <LabelBgIcon className={styles.labelBgIcon} />
          <span className={styles.labelText}>{labelText}</span>
        </div>
        <div className={cx(styles.container, styles[`type__${type}`])}>
          <div>
            <h4 className={styles.title}>{title}</h4>
            <p className={styles.desc}>{desc}</p>
            <div className={styles.panel}>
              <span>{numberOfLegalEntities}</span>
              <span>{revenue}</span>
            </div>
            <div className={styles.featuresList}>
              {features.map((feature) => (
                <div className={styles.feature}>
                  <DoneIcon className={styles[`featureIcon__green`]} />
                  <span className={styles.featureText}>{feature.name}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            {daysLeft && (
              <div className={styles.daysLeftText}>
                До окончания подписки осталось: {daysLeft}
              </div>
            )}
            <div className={styles.footer}>
              <div className={styles.priceContainer}>
                {discountPrice !== initialPrice && (
                  <div className={styles.initialPrice}>
                    {initialPrice && (
                      <>
                        {initialPrice} <span className={styles.ruble}>₽</span>
                      </>
                    )}
                  </div>
                )}
                <div
                  className={cx(
                    styles.discountPrice,
                    !initialPrice && styles.currentPrice
                  )}
                >
                  {discountPrice && (
                    <>
                      {discountPrice} <span className={styles.ruble}>₽</span>
                    </>
                  )}
                </div>
              </div>
              {showPayButton && (
                <Button
                  className={styles.paymentButton}
                  variant="primary"
                  onClick={onClick}
                >
                  Оплатить
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default TariffCard;
